import _taggedTemplateLiteral from "/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import styled from 'styled-components';
import { enumerate } from '../../common';
import { defaultSpacing, defaultBorderRadius } from '../../common/props/constants';
export var MainLayoutStyle = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: flex;\n    margin: auto;\n    padding: ", "px;\n    max-width: 100%;\n    min-height: 100%;\n    box-shadow: var(--defaultShadowColor);\n    border-radius: ", "px;\n\n    &,\n    & * {\n        box-sizing: border-box;\n    }\n\n    width: ", ";\n"])), defaultSpacing, defaultBorderRadius, function (props) {
  return props.isFluid ? '100%' : props.isContained ? 'fit-content' : enumerate.width + 'px';
});